export default __webpack_public_path__ + "static/gallery-art-sculpture-1f564c2ab991c0400b52a36c6c88faeb.jpg";